export default __webpack_public_path__ + "static/magnet-42401b3797f91fdd781a45674adc1964.png";